import "slick-carousel"; // core Slick functionality

import $ from "jquery";

const imageGallerySlider = (el) => {
    const $el = $(el);

    const pagination = $(".js-pagination");

    const previousArrow = $(".js-pagination .js-prev");
    const nextArrow = $(".js-pagination .js-next");
    const slideCounter = $(".image-gallery .js-slide-counter");

    $el.slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        centerMode: false,
        variableWidth: true,
        draggable: false,
        appendArrows: pagination,
        prevArrow: previousArrow,
        nextArrow: nextArrow,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    // centerPadding: '40px',
                    draggable: true,
                },
            },
        ],
    });

    let currentSlide = 0;
    let activeSlide = 0;

    $el.on("afterChange", function (e) {
        activeSlide = Number(
            $el
                .find(".slick-track")
                .find(".slick-current")
                .attr("data-slick-index")
        );

        currentSlide = Number(activeSlide + 1);
        slideCounter.text(`${currentSlide}`);
    });
};

export default imageGallerySlider;
